import { useEffect, useState } from 'react';

function TestimonialsSection({ testimonials }) {
  const [activeIndex, setActiveIndex] = useState(0);

  useEffect(() => {
    if (!testimonials.length) {
      return undefined;
    }

    const timer = setInterval(() => {
      setActiveIndex((prev) => (prev + 1) % testimonials.length);
    }, 5000);

    return () => clearInterval(timer);
  }, [testimonials.length]);

  if (!testimonials.length) {
    return null;
  }

  return (
    <section className="pb-16">
      <div className="overflow-hidden rounded-3xl border border-brand-petal/80 bg-white shadow-sm">
        <div
          className="flex transition-transform duration-700 ease-out"
          style={{ transform: `translateX(-${activeIndex * 100}%)` }}
        >
          {testimonials.map((item) => (
            <blockquote key={item.name} className="w-full shrink-0 p-7 sm:p-10">
              <p className="text-xl leading-9 text-brand-text/90 sm:text-2xl">"{item.quote}"</p>
              <footer className="mt-6 text-sm font-semibold uppercase tracking-[0.2em] text-brand-primary">
                {item.name}
              </footer>
            </blockquote>
          ))}
        </div>
      </div>

      <div className="mt-5 flex items-center justify-center gap-2">
        {testimonials.map((item, index) => (
          <button
            key={item.name}
            type="button"
            onClick={() => setActiveIndex(index)}
            aria-label={`Go to testimonial ${index + 1}`}
            className={`h-2.5 w-8 rounded-full transition ${
              activeIndex === index ? 'bg-brand-primary' : 'bg-brand-petal hover:bg-brand-primary/60'
            }`}
          />
        ))}
      </div>
    </section>
  );
}

export default TestimonialsSection;